// @flow
import styled from 'styled-components';
import {
  textNormal,
  textBlack,
  textSemiBold,
  textBold,
  textBoldLoose,
} from './css';
import { Text5 } from './Text';

export const Text5Normal = styled(Text5)`
  ${textNormal};
`;

export const Text5Black = styled(Text5)`
  ${textBlack};
`;

export const Text5Bold = styled(Text5)`
  ${textBold};
`;

export const Text5SemiBold = styled(Text5)`
  ${textSemiBold};
`;

export const Text5BoldLoose = styled(Text5)`
  ${textBoldLoose};
`;
